import { Star } from '@phosphor-icons/react';

export function StarRating({ rating, size = 16, showCount = false, count = 0 }) {
  return (
    <div className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => (
        <Star 
          key={i}
          size={size}
          weight={i < Math.floor(rating) ? "fill" : "regular"}
          className={i < Math.floor(rating) ? "text-nexa-gold" : "text-nexa-border"}
        />
      ))}
      {showCount && (
        <span className="text-sm text-muted-foreground ml-1">
          ({count} reviews)
        </span>
      )}
    </div>
  );
}
